import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  Typography,
  Grid,
  IconButton,
  Menu,
  MenuItem
} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import PublicIcon from '@material-ui/icons/Public';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import {
  setExploreSelectedViewId,
  setConfirmationModalState,
  deleteExploreView
} from 'store/actions';
import { Constants } from 'utilities/constants';
import { sendClientLog } from 'services/logService';

const ViewCard = ({ classes, user, view, onClick, selectedViewId, selectedView, selectedViewIsDirty,
  setConfirmationModalState, deleteExploreView }) => {
  const {
    txnOppUnassignedBin,
    listItem,
    listItemSelected,
    listItemAvatar,
    queueAvatar,
    blueAvatar,
    greenAvatar,
    avatarText,
    listItemContent,
    portfolioNameContainer,
    textPrimary,
    textSecondary
  } = classes;
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);

  const openMoreMenu = (e) => {
    setMoreMenuAnchorEl(e.currentTarget);
  }

  const closeMoreMenu = () => {
    setMoreMenuAnchorEl(null);
  }

  const handleListItemClick = (event, task) => {
    onClick(view.id);
    sendClientLog('Info',`Explore Views - User clicked ViewCard with view id ${view.id}`);
  }

  const handleDeleteView = () => {
    closeMoreMenu();
    setConfirmationModalState({
			isModalOpen: true,
      handleConfirmation: () => {
				closeConfirmationModal();
        deleteExploreView(view.id);
        if (view.id === 'temp') {
          sendClientLog('Info',`Explore Views - User discarded temporary view from ViewCard menu`);
        } else if (view.id === 'system') {
          sendClientLog('Info',`Explore Views - User discarded system view from ViewCard menu`);
        } else {
          sendClientLog('Info',`Explore Views - User clicked and confirmed Delete on ViewCard menu for view id ${view.id}`);
        }
			},
      handleCancellation: () => {
				closeConfirmationModal();
			},
      titleText: 'Confirm',
      contentText: `Are you sure you want to ${view.id === 'temp' || view.id === 'system' ? 'discard' : 'delete'} this view?`
		})
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }

  const isSelected = view.id === selectedViewId;
  const nameToDisplay = isSelected ? selectedView?.name ?? view.name : view.name;
  const isTempOrSystem = view.id === 'temp' || view.id === 'system';
  const isUserCreatedView = user.id === view.createdByUserId || isTempOrSystem;
  return (
    <div
      className={txnOppUnassignedBin}
      // id={`${bin.id}${task.id}`}
    >
      <ListItem
        button
        className={listItem}
        selected={isSelected}
        classes={{ selected: listItemSelected }}
        onClick={e => handleListItemClick(e)}
      >
        {isSelected &&
          <div style={{ height: 72, width: 6, backgroundColor: '#00d0ff' }} />
        }
          <ListItemAvatar className={listItemAvatar}>
            <Avatar className={classNames(queueAvatar, isUserCreatedView ? greenAvatar : blueAvatar)}>
              {view.privacy === 'Private'
                ? <PersonIcon />
                : <PublicIcon />
              }
              <Typography className={ avatarText }/>
            </Avatar>
          </ListItemAvatar>
        <div className={listItemContent}>
          <Grid container wrap='nowrap' spacing={0} alignItems='center' direction='row' justifyContent='space-between'>
            <Grid item className={portfolioNameContainer}>
              <Typography className={textPrimary} component="div">{nameToDisplay}</Typography>
              <Typography className={classes.textUnsaved} component="div">{(isSelected && selectedViewIsDirty ? '*' : '')}</Typography>
            </Grid>
            {/* <Grid item><Typography component="div">{'taskId'}</Typography></Grid> */}
          </Grid>
          <Typography className={textSecondary} component="div">{view.description ?? 'Description'}</Typography>
          {/* <Typography className={textSecondary} component="div">
            <span className={inlinePadding}>{'importName'}</span>
          </Typography>
          <div className={badgeContainer}>
            <KeyValueBadge small name='Beds' value={'beds'} />
            <KeyValueBadge small name='Baths' value={'baths'} />
            <KeyValueBadge small name='Sqft' value={'sqft'} />
            <div style={{ flexGrow: 1 }} />
            <OpportunityStatusChip txnOpp={'task'} highlightStatus={'highlightStatus'} />
          </div> */}
          <div style={{ height: 32 }}></div>
        </div>
      </ListItem>
      {(isUserCreatedView || user.roles.administrator) &&
        <>
          <IconButton
            className={classes.detailButton}
            onClick={openMoreMenu}
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu
            anchorEl={moreMenuAnchorEl}
            open={Boolean(moreMenuAnchorEl)}
            onClose={closeMoreMenu}
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'bottom'
            }}
          >
            <MenuItem onClick={handleDeleteView}>{(isTempOrSystem ? 'Discard' : 'Delete') + ' view'}</MenuItem>
          </Menu>
        </>
      }
    </div>
  );
}
const styles = theme => ({
  txnOppUnassignedBin: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 8px',
    position: 'relative'
  },
  textPrimary: {
    fontSize: '.85rem',
    fontWeight: '500',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  textUnsaved: {
    fontSize: '.85rem',
    fontWeight: '500',
    display: 'inline-block',
  },
  inlinePadding: {
    margin: '0px 5px 0px 0px',
  },
  textSecondary: {
    fontSize: '.75rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    margin: '-3px 0px 0px'
  },
  listItem: {
    padding: 0,
    borderRadius: 4,
    borderBottom: '1px solid #e4e4e4',
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: 73
  },
  listItemContent: {
    padding: '3px 8px',
    width: '100%',
    height: '100%',
  },
  listItemSelected: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)!important'
  },
  listItemAvatar: {
    minWidth: 'unset',
  },
  queueAvatar: {
    height: '72px',
    width: '24px',
    borderRadius: 0
  },
  completed: {
    height: '72px',
    width: '24px',
    backgroundColor: '#31c700',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    marginRight: '0px',
    height: 68,
    width: 24,
    borderRadius: 0
  },
  avatarText: {
    fontSize: '1.55rem',
    fontWeight: '500',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blueAvatar: {
    backgroundColor: theme.palette.primary.main
  },
  greenAvatar: {
    backgroundColor: '#31c700'
  },
  portfolioNameContainer: {
    overflow: 'hidden',
    display: 'flex'
  },
  badgeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '4px'
  },
  inlineText: {
    display: 'inline-block',
    whiteSpace: 'pre',
    fontSize: '.75rem',
  },
  inlineSearchText: {
    display: 'inline-block',
    whiteSpace: 'pre',
    fontWeight: 'bold',
    backgroundColor: 'yellow',
    color: 'black',
    fontSize: '.75rem',
  },
  inlinePrimarySearchText: {
    display: 'inline-block',
    whiteSpace: 'pre',
    fontWeight: 'bold',
    backgroundColor: 'yellow',
  },
  visibilityButton: {
    padding: 2,
    margin: '0 -4px 0 4px'
  },
  detailButton: {
    padding: 4,
    position: 'absolute',
    right: 8,
    top: 20
  }
});

const mapStateToProps = ({ appState, exploreViews }) => {
  return {
    user: appState.user,
    selectedViewId: exploreViews.selectedViewId,
    selectedView: exploreViews.selectedView,
    selectedViewIsDirty: exploreViews.selectedViewIsDirty
  }
};
const mapDispatchToProps = {
  setExploreSelectedViewId,
  setConfirmationModalState,
  deleteExploreView
};

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ViewCard);
